// @core/api/endpoints/form/install_form_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FormResponse,
  InstallFormTemplateRequest,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Install form template
 * Creates a new form from a template. The new form is created in draft status with all template fields and settings.
 */
export async function InstallFormTemplate(
  template_id: string,
  data: InstallFormTemplateRequest,
  options?: RequestOptions
): Promise<FormResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/templates/:template_id/install`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.post<FormResponse>(requestPath, data, requestOptions);
}
